<template>
  <div class="forgot-pass-email" style="background: linear-gradient(rgb(0, 19, 36) 0%, rgb(27, 41, 51) 100%);">
    <form-default
      :contentTitle="$t('views.ForgotPassEmail.contentTitle')"
      :titleLogin="$t('views.ForgotPassEmail.titleLogin')"
      :inputs="inputs"
      :button="button"
    ></form-default>
    <alert-error
      :textError="messageErrorForgotEmail"
      :nameButton="buttonText"
      action="errorForgotEmail"
      v-if="errorForgotEmailModal"
    ></alert-error>
  </div>
</template>
<script>
import Bus from '@/main.js';
import FormDefault from '../../components/Forms/FormDefault';
import AlertError from '../../components/Alerts/AlertError';
import userEmail from './ForgotPass.vue';

export default {
  components: {
    FormDefault,
    AlertError,
    userEmail,
  },
  data() {
    return {
      colors: {},
      newDefinedPassword: '',
      messageErrorForgotEmail: '',
      buttonText: '',
      errorForgotEmailModal: false,
      userData: {},
      toLocalStorage: {},
      inputs: [
        {
          placeholder: this.$t('views.ForgotPassEmail.inputsPlaceholder[0]'),
          type: 'password',
          name: 'newPass',
        },
        {
          placeholder: this.$t('views.ForgotPassEmail.inputsPlaceholder[1]'),
          type: 'password',
          name: 'confirmPass',
        },
      ],
      button: {
        name: this.$t('views.ForgotPassEmail.button'),
        typeLogin: 'email',
        action: 'newPass',
      },
    };
  },
  async created() {
    Bus.$on('newPass', this.newPass);
    Bus.$on('errorForgotEmail', this.errorForgotEmail);
    // const emailReq = await this.$http.get(`https://us-central1-authentication-service-01.cloudfunctions.net/api/?email=${email}`)
    // console.log("emailReq", emailReq)
    this.colors = JSON.parse(localStorage.getItem('colors'));
    if (!this.colors) {
      let defaultColors = {
        primary: "#58fdf4",
        secondary: "#fe4778",
        theme: "dark",
        clientLogoPath: "",
        dark: {
            to: "#192733",
            from: "#001324",
        },
        light: {
            to: "#ccc",
            from: "#fff",
        },
      }
      localStorage.setItem('colors', JSON.stringify(defaultColors));
      this.colors = JSON.parse(localStorage.getItem('colors'));
    }

    this.userData = localStorage.getItem('user');
    if (!this.userData) {
      const { userId } = this.$route.query;
      const userReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS}/users/${userId}`);
      this.toLocalStorage = {
        name: userReq.body.name,
        email: userReq.body.email,
        cpf: userReq.body.cpf,
      };
      localStorage.setItem('user', JSON.stringify(this.toLocalStorage));
      this.userData = localStorage.getItem('user');
    }
  },
  destroyed() {
    Bus.$off('newPass', this.newPass);
    Bus.$off('errorForgotEmail', this.errorForgotEmail);
  },
  methods: {
    errorForgotEmail() {
      this.newDefinedPassword = document.getElementById('confirmPass').value;
      // console.log("NEW PASS: ", this.newDefinedPassword)
      this.newDefinedPassword = '';
      this.errorForgotEmailModal = false;
    },
    async newPass() {
      this.newDefinedPassword = document.getElementById('confirmPass').value;
      // const { oobCode } = this.$route.query;
      const userInfos = JSON.parse(this.userData);
      const bodyReq = {
        password: this.newDefinedPassword,
        name: userInfos.name,
        email: userInfos.email,
        cpf: userInfos.cpf,
      };
      const self = this;
      try {
        const resetPassword = await this.$http.post(
          `${process.env.VUE_APP_AUTH_DOMAIN}/users/no-email`,
          bodyReq,
        );
        self.$router.replace('/forgot-pass-success');
      } catch (error) {
        self.errorForgotEmailModal = true;
        self.messageErrorForgotEmail = self.$t(
          'views.ForgotPassEmail.messageErrorForgotEmail',
        );
        self.buttonText = self.$t('views.ForgotPassEmail.button');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.forgot-pass-email {
  min-height: 100vh;
  display: flex;
}
</style>
